import IntroductionForm from "../services/api/introductionForm";
import { APPOINTMENT_ENTRY } from "./formFields";

export const appointmentQuestions = [
  {
    questionId: 1,
    questionType: "NUMBER",
    key: APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE,
    questionText: "Years of active practice",
    questionText2: "More than 8 years for MD/WD more than 4 years for YMD/YWD",
    answerType: "integer",
    usedFor: ["DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 2,
    key: APPOINTMENT_ENTRY.IS_BSG_STUDY_EXAMINATION_CLEAR,
    questionType: "RADIO",
    questionText: "BSG study examination(s) cleared",
    answerType: "boolean",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 3,
    key: APPOINTMENT_ENTRY.IS_GHONZON_RECEIVED,
    questionType: "RADIO",
    questionText: "Gohonzon received",
    answerType: "boolean",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 4,
    key: APPOINTMENT_ENTRY.DATE_RECEVING_GHONZON,
    questionType: "DATE",
    questionText: "Date of receiving Gohonzon",
    answerType: "date",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 5,
    key: APPOINTMENT_ENTRY.NUMBER_OF_SHAKUBUL,
    questionType: "NUMBER",
    questionText: "Number of Shakubul",
    answerType: "integer",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 6,
    key: APPOINTMENT_ENTRY.NO_OF_HOME_VISITS_WEEK,
    questionType: "NUMBER",
    questionText: "Number of home visits a week",
    answerType: "integer",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 7,
    key: APPOINTMENT_ENTRY.IS_PROG_ATTENDED,
    questionType: "radio",
    questionText: "SGI TRG CRS/BSG DAISEIDO TRG program attended before",
    answerType: "boolean",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 8,
    key: APPOINTMENT_ENTRY.PARTICIPATION_YEAR,
    parentQuestionId: 7,
    questionType: "YEAR",
    questionText: "If yes, year of last participation",
    answerType: "year",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 9,
    key: APPOINTMENT_ENTRY.DOING_GONGYO_AND_DAIKOMU,
    questionType: "NUMBER",
    questionText:
      "Doing Gongyo & Daimoku regularly, attending bsg meetings(Discussion meetings & Gosho/NHR study mtgs) with active practice of more than 1 year for MD/WD(6 months for YMD/YWD)",
    answerType: "integer",
    usedFor: ["BLOCK"],
  },
  {
    questionId: 10,
    key: APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION,
    questionType: "TEXT",
    questionText:
      "Position held in youth division, if being appointed directly upon graduation(Chapter/District Chief for Block Chief appointment)",
    answerType: "string",
    usedFor: ["BLOCK", "DISTRICT"],
  },
  {
    questionId: 11,
    key: APPOINTMENT_ENTRY.REMARK,
    questionType: "TEXT",
    questionText: "General remarks",
    questionText2: "For example: ",
    answerType: "string",
    usedFor: ["BLOCK", "DISTRICT", "CHAPTER"],
  },
  {
    questionId: 12,
    questionType: "RADIO",
    key: APPOINTMENT_ENTRY.IS_DUAL,
    questionText: "Any dual position",
    answerType: "boolean",
    usedFor: ["DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 13,
    key: APPOINTMENT_ENTRY.VC_SUBSCRIPTION,
    questionType: "RADIO",
    questionText: "VC Subscription",
    answerType: "boolean",
    usedFor: ["DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 14,
    key: APPOINTMENT_ENTRY.MADE_EFFORTS_TOWARDS,
    questionType: "RADIO",
    questionText: "Made efforts towards fostering capable leaders",
    answerType: "boolean",
    usedFor: ["DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  },
  {
    questionId: 15,
    key: APPOINTMENT_ENTRY.HAS_BEEN_BLOCK_CHEIF,
    questionType: "RADIO",
    questionText:
      "Has been Block Chief for more than 1 year of which 6 months as main BC in MD/WD",
    questionText2: "6 months as Block Chief in YMD/YWD",
    answerType: "boolean",
    usedFor: ["DISTRICT"],
  },
  {
    questionId: 16,
    key: APPOINTMENT_ENTRY.ATTENDING_MEETING,
    questionType: "RADIO",
    questionText:
      "Attending Discussion Meeting, District Planning Meeting, Gosho/NHR Study Meeting and other leader meetings such as DOU, etc",
    answerType: "boolean",
    usedFor: ["DISTRICT"],
  },
  {
    questionId: 17,
    questionType: "RADIO",
    key: APPOINTMENT_ENTRY.HAS_BEEN_DISTRICT_CHIEF,
    questionText:
      "Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year should be main DC not Deputy",
    answerType: "boolean",
    usedFor: ["CHAPTER"],
  },
  {
    questionId: 18,
    key: APPOINTMENT_ENTRY.HAS_BEEN_CHAPTER_CHEIF,
    questionType: "RADIO",
    questionText:
      "Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year should be main CC not Deputy",
    answerType: "boolean",
    usedFor: ["REGION"],
  },
  {
    questionId: 19,
    key: APPOINTMENT_ENTRY.HAS_BEEN_REGION_CHEIF,
    questionType: "RADIO",
    questionText:
      "Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year should be main RC not Deputy",
    answerType: "boolean",
    usedFor: ["ZONE"],
  },
  {
    questionId: 20,
    questionType: "RADIO",
    questionText:
      "Has been MD/WD DC/DDC for more than 2 years (1 year for YMD/YWD) out of which at least 1 year should be main ZC not Deputy",
    answerType: "boolean",
    usedFor: ["AREA"],
  },
  {
    questionId: 21,
    questionType: "RADIO",
    questionText:
      "Is actively attending leaders meeting DOU, Gosho/NHR Study Meeting and conducting monthly discussion meeting and district planning meeting",
    answerType: "boolean",
    usedFor: ["DISTRICT", "CHAPTER"],
  },
  {
    questionId: 22,
    key: APPOINTMENT_ENTRY.ATTENDING_BSG_MEETING_INCLUDING_NHR_GOSHO,
    questionType: "RADIO",
    questionText:
      "Is regularly attending BSG meeting including NHR/Gosho Study Meeting",
    answerType: "boolean",
    usedFor: ["REGION"],
  },
  {
    questionId: 23,
    key: APPOINTMENT_ENTRY.ACTIVELY_PARTICIPATING_LEADER_MEETING,
    questionType: "RADIO",
    questionText:
      "Is actively participating in Leader meeting (DOU) and taking monthly Gosho Meeting from time to time",
    answerType: "boolean",
    usedFor: ["REGION"],
  },
  {
    questionId: 24,
    key: APPOINTMENT_ENTRY.CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION_ENTRANCE_EXAM,
    questionType: "RADIO",
    questionText:
      "Has cleared the introductory level examination (Entrance exam for YMD/YWD)",
    answerType: "boolean",
    usedFor: ["REGION"],
  },
  {
    questionId: 25,
    key: APPOINTMENT_ENTRY.OWN_GOHONZON_OR_FAMILY_GOHONZON,
    questionType: "RADIO",
    questionText:
      "(For MD/WD/YMD/YWD) Has his/her own Gohonzon or Family Gohonzon if living with practicing member",
    answerType: "boolean",
    usedFor: ["REGION", "ZONE", "AREA"],
  },
  {
    questionId: 26,
    key: APPOINTMENT_ENTRY.ACTIVELY_SUPPORTING_LEADERS_MEETING,
    questionType: "RADIO",
    questionText:
      "Actively supporting/conducting leaders meeting, taking monthly Gosho study from time to time and regularly attending Gosho/NHR meetings",
    answerType: "boolean",
    usedFor: ["ZONE", "AREA"],
  },
  {
    questionId: 27,
    key: APPOINTMENT_ENTRY.CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION,
    questionType: "RADIO",
    questionText:
      "MD/WD - Cleared the introductory level examination (YMD/YWD - Cleared the entrance level examination)",
    answerType: "boolean",
    usedFor: ["ZONE", "AREA"],
  },
];

export const APPOINTMENT_TABLES_MAP = {
  APPOINTMENT_APPLY: "APPOINTMENT_APPLY",
  APPOINTMENT_REVIEW: "APPOINTMENT_REVIEW",
  REVIEW_APPOINTMENT: "REVIEW_APPOINTMENT",
  PARTIAL_REVIEW_APPOINTMENT: "PARTIAL_REVIEW_APPOINTMENT",
  PARTIAL_APPROVED_APPOINTMENT: "PARTIAL_APPROVED_APPOINTMENT",
  APPOINTMENT_INTERVIEW: "APPOINTMENT_INTERVIEW",
  APPOINTMENT_PROPOSE_APPLICATION: "APPOINTMENT_PROPOSE_APPLICATION",
  APPOINTMENT_SECOND_APPROVAL_APPLICATION:
    "APPOINTMENT_SECOND_APPROVAL_APPLICATION",
  APPOINTMENT_PROPOSE_MARK_APPLICATION: "APPOINTMENT_PROPOSE_MARK_APPLICATION",
  APPOINTMENT_TRACKING: "APPOINTMENT_TRACKING",
};

export const PREVIEW = "preview";

export const STRUCTURE_LEVEL = {
  BLOCK: "BLOCK",
  DISTRICT: "DISTRICT",
  CHAPTER: "CHAPTER",
  REGION: "REGION",
  ZONE: "ZONE",
  AREA: "AREA",
  DEFAULT: "DEFAULT",
};

export const STRUCTURE_LEVEL_LIST = [
  // don't change order
  STRUCTURE_LEVEL.BLOCK,
  STRUCTURE_LEVEL.DISTRICT,
  STRUCTURE_LEVEL.CHAPTER,
  STRUCTURE_LEVEL.REGION,
  STRUCTURE_LEVEL.ZONE,
  STRUCTURE_LEVEL.AREA,
];

export const STRUCTURE_LEVEL_MAPPER = {
  DISTRICT: "BLOCK",
  CHAPTER: "DISTRICT",
  REGION: "CHAPTER",
  ZONE: "REGION",
  AREA: "ZONE",
};

export const STRUCTURE_PARENT_MAPPER = {
  ZONE: "AREA",
  REGION: "ZONE",
  CHAPTER: "REGION",
  DISTRICT: "CHAPTER",
  BLOCK: "DISTRICT",
};

export const STRUCTURE_LEVEL_DEPTH = {
  DISTRICT: ["DISTRICT", "CHAPTER", "REGION", "ZONE", "AREA"],
  CHAPTER: ["CHAPTER", "REGION", "ZONE", "AREA"],
  REGION: ["REGION", "ZONE", "AREA"],
  ZONE: ["ZONE", "AREA"],
  AREA: ["AREA"],
};

export const SPLIT_API_MAPPER = {
  [STRUCTURE_LEVEL.DEFAULT]: IntroductionForm.getAllArea,
  [STRUCTURE_LEVEL.AREA]: IntroductionForm.getAllZones,
  [STRUCTURE_LEVEL.ZONE]: IntroductionForm.getAllRegions,
  [STRUCTURE_LEVEL.REGION]: IntroductionForm.getAllChapters,
  [STRUCTURE_LEVEL.CHAPTER]: IntroductionForm.getAllDistricts,
  [STRUCTURE_LEVEL.DISTRICT]: IntroductionForm.getAllBlocks,
};

export const Division = {
  MD: "MD",
  WD: "WD",
  YWD: "YWD",
  YMD: "YMD",
};
